import script from "./PromotionsWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./PromotionsWidget.vue?vue&type=script&setup=true&lang=js"

import "./PromotionsWidget.vue?vue&type=style&index=0&id=25317ccc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25317ccc"]])

export default __exports__